import React, {useEffect, useState} from 'react';
import Title from "../components/Title";
import Button from "../components/Button";
import Separator from "../components/Separator";
import {apiRequest} from "../utils/api";
import {useAuth} from "../context/AuthContext";

const AdminUsers = () => {
    const {user, logout} = useAuth();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [form, setForm] = useState({login: '', password: '', role: 'user'});
    const [isSaving, setIsSaving] = useState(false);

    const loadUsers = async () => {
        setLoading(true);
        setError('');

        try {
            const response = await apiRequest('admin/users.php', {method: 'GET', headers: {}});
            setUsers(response.users || []);
        } catch (loadError) {
            setError(loadError.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadUsers();
    }, []);

    const handleCreate = async () => {
        setIsSaving(true);
        setError('');

        try {
            await apiRequest('admin/users_create.php', {
                method: 'POST',
                body: JSON.stringify(form),
            });
            setForm({login: '', password: '', role: 'user'});
            await loadUsers();
        } catch (saveError) {
            setError(saveError.message);
        } finally {
            setIsSaving(false);
        }
    };

    const toggleLock = async (selectedUser) => {
        const endpoint = selectedUser.status === 'active' ? 'admin/users_lock.php' : 'admin/users_unlock.php';

        try {
            await apiRequest(endpoint, {
                method: 'POST',
                body: JSON.stringify({userId: selectedUser.id}),
            });
            await loadUsers();
        } catch (toggleError) {
            setError(toggleError.message);
        }
    };

    return (
        <div className="wrap admin_page">
            <div className="topbar">
                <Title title={"Users"}/>
                <div className="topbar_actions">
                    <span className="user_badge">{user?.login}</span>
                    <Button text={"Logout"} handleClick={logout}/>
                </div>
            </div>
            <Separator/>

            <div className="form admin_create_form">
                <input
                    type="text"
                    placeholder="Login"
                    value={form.login}
                    onChange={(e) => setForm({...form, login: e.target.value})}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={form.password}
                    onChange={(e) => setForm({...form, password: e.target.value})}
                />
                <select value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}>
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                </select>
                <Button
                    text={isSaving ? "Creating..." : "Create user"}
                    primary={true}
                    disabled={isSaving || !form.login.trim() || !form.password}
                    handleClick={handleCreate}
                />
            </div>

            {error && <p className="auth_error">{error}</p>}

            {loading ? (
                <p>Loading users...</p>
            ) : (
                <div className="users_table_wrap">
                    <table className="users_table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Login</th>
                            <th>Role</th>
                            <th>Status</th>
                            <th>Last login</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {users.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.login}</td>
                                <td>{item.role}</td>
                                <td>{item.status}</td>
                                <td>{item.last_login_at || '-'}</td>
                                <td>
                                    <button
                                        className={`btn ${item.status === 'active' ? 'red' : 'green'} table_btn`}
                                        disabled={item.id === user?.id}
                                        onClick={() => toggleLock(item)}
                                    >
                                        {item.status === 'active' ? 'Lock' : 'Unlock'}
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AdminUsers;
